import * as Yup from "yup";

const NewsletterFormSchema = () => {
  return Yup.object().shape({
    email: Yup.string()
      .email("Nieprawidłowy adres email")
      .required("Email jest wymagany"),
    terms: Yup.boolean().oneOf([true], "Musisz zaakceptować regulamin"),
  });
};

export default NewsletterFormSchema;
